import { FeaturePermissionAnyDirective } from './feature-permission-any.directive';
import { TprecmAuthorizationService } from './../tprecm-authorization.service';
import { SubFeaturePermissionDirective } from './sub-feature-permission.directive';
import { Directive, AfterContentInit, ContentChildren, QueryList, Input } from '@angular/core';
import { FeaturePermissionAllDirective } from './feature-permission-all.directive';
import { FeaturePermissionNoneDirective } from './feature-permission-none.directive';

@Directive({
  selector: '[featurePermission]'
})
export class FeaturePermissionDirective implements AfterContentInit {

  @ContentChildren(SubFeaturePermissionDirective, { descendants: true })
  children: QueryList<SubFeaturePermissionDirective>;

  @ContentChildren(FeaturePermissionAnyDirective, { descendants: true })
  any: QueryList<FeaturePermissionAnyDirective>;

  @ContentChildren(FeaturePermissionAllDirective, { descendants: true })
  all: QueryList<FeaturePermissionAllDirective>;

  @ContentChildren(FeaturePermissionNoneDirective, { descendants: true })
  none: QueryList<FeaturePermissionNoneDirective>;

  @Input()
  private readonly featurePermission: string;

  constructor(
    private readonly service: TprecmAuthorizationService
  ) { }

  setDisabledChildren() {
    const authorized = this.children
      .map(async child => {
        const allowed = await this.service.getAuthorizationByFeaturePermission(this.featurePermission, child.getPermission());
        return { child, allowed };
      });

    Promise.all(authorized)
      .then(values => {

        const filtered = values
          .filter(({ allowed }) => allowed);

        if (filtered.length === values.length) {
          this.all.forEach(child => child.disabled = false);
          this.any.forEach(child => child.disabled = false);
        } else if (filtered.length > 0) {
          this.any.forEach(child => child.disabled = false);
        } else {
          this.none.forEach(child => child.disabled = false);
        }


        filtered.forEach(({ child }) => child.disabled = false);
      });

  }

  ngAfterContentInit() {
    // Check for updated to DOM
    this.children.changes
      .subscribe(() => this.setDisabledChildren());

    // Initial DOM update and reloads
    this.setDisabledChildren();
  }

}
